export default __webpack_public_path__ + "static/media/bxl-linkedin-square.5c4ac342.svg";